module.exports = {"640303001":"红寺堡区新民街道","640303100":"红寺堡区红寺堡镇","640303101":"红寺堡区太阳山镇","640303200":"红寺堡区大河乡","640303201":"红寺堡区新庄集乡","640303202":"红寺堡区柳泉乡","640303400":"红寺堡工业园区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640303.json
// module id = 3036
// module chunks = 0